import { api } from './index';
import { CoverageCheckupPayload } from '../../types';
import { CoverageCheckupState } from '../../store/step';
import { manipulateData } from './dataManipulator';
import { RecaptchaCompleteParam, logDynatraceError } from '@frontman/utils';

async function postCoverageCheckupResults(
  requestBody: CoverageCheckupState,
  recaptchaParams: RecaptchaCompleteParam
): Promise<string> {
  const payload: CoverageCheckupPayload = manipulateData(requestBody);
  try {
    const response = await api.post('/create', {
      ...payload,
      ...recaptchaParams,
    });
    return response.data.data.uuid;
  } catch (error) {
    logDynatraceError(error as Error);
    throw error;
  }
}

export { postCoverageCheckupResults };
